import "@/listeners/amplitudeListeners";
import "@/listeners/preventPageReload";
import "@/listeners/downloadListener";
import "@/listeners/notifyAccountExpirationListener";
import * as Sentry from "@sentry/vue";
import { Breadcrumb, BreadcrumbHint } from "@sentry/types";
import router from "@/router";
import Vue from "vue";
import { getStaticConfiguration } from "@/config/app";

export function initialize(): void {
  getStaticConfiguration().then((config) => {
    if (config.SENTRY_DSN) {
      Sentry.init({
        Vue,
        dsn: config.SENTRY_DSN,
        ignoreErrors: [
          "Avoided redundant navigation to current location",
          "Redirected when going from",
        ],
        integrations: [
          Sentry.thirdPartyErrorFilterIntegration({
            filterKeys: ["pillar-science-sentry-application-key"],
            behaviour: "apply-tag-if-exclusively-contains-third-party-frames",
          }),
          Sentry.browserTracingIntegration({
            router,
            beforeStartSpan(context: StartSpanOptions) {
              const route = router.currentRoute;
              if (route && route.name) {
                return {
                  ...context,
                  name: route.name,
                };
              }

              return context;
            },
          }),
        ],
        tracePropagationTargets: [
          "api.pillar.science",
          "staging.api.pillar.science",
          "demo.api.pillar.science",
          "sandbox.api.pillar.science",
        ],
        environment: config.SENTRY_ENVIRONMENT,
        release: config.SENTRY_RELEASE,
        //tracesSampleRate: config.sentryTraceSampleRate || 0.01,
        attachStacktrace: true,
        beforeBreadcrumb(
          breadcrumb: Breadcrumb,
          hint?: BreadcrumbHint
        ): Breadcrumb | null {
          if (breadcrumb.category === "ui.click" && hint) {
            const { target } = hint.event;

            if (target.hasAttribute("sentry-breadcrumb")) {
              breadcrumb.message = `${target.getAttribute(
                "sentry-breadcrumb"
              )} | ${breadcrumb.message}`;
            }
          }

          return breadcrumb;
        },
      });

      Sentry.setTag("application", "Frontend");
    }
  });
}
